import { getWhiteLabelConfig } from "~/utils/white-label";

import {
  ALLI_TENANT_UUID_HEADER,
  AUTH_TOKEN_STORAGE_KEY,
  COMMON_HEADERS,
} from "../helpers/consts";

export const createSecurityWorker =
  (storage: Storage = window.localStorage) =>
  () => {
    const token = storage.getItem(AUTH_TOKEN_STORAGE_KEY);
    const tenantUuid = getWhiteLabelConfig().uuid;

    const headers: Record<string, string> = {
      ...COMMON_HEADERS,
      ...(tenantUuid ? { [ALLI_TENANT_UUID_HEADER]: tenantUuid } : {}),
    };

    if (token) {
      headers.Authorization = `Token ${token}`;
    }

    return { headers };
  };
